export const API_BASE_URL = 'http://localhost:8080';
export const ACCESS_TOKEN_NAME = 'login_access_token';
export const API_MOSA_URL = 'https://cors-anywhere.herokuapp.com/http://mosaadmin.smsoman.com';